import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "organizationList",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/OrganizationList.vue"),
  },
  {
    path: ":id",
    name: "organizationDetail",
    meta: {
      roles: [
        ...ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION.ROLES,
        ...ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION_DETAIL.ROLES,
      ],
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/OrganizationDetail.vue"),
  },
  {
    path: PATH.PREFERENCE,
    name: "preference",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.PREFERENCE.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.PREFERENCE.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/OrganizationPreference.vue"),
  },
  {
    path: PATH.CREATE_ORGANIZATION,
    name: "createOrganization",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.CREATE_ORGANIZATION.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.CREATE_ORGANIZATION.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/CreateOrganization.vue"),
  },
  {
    path: PATH.UPDATE_ORGANIZATION,
    name: "updateOrganization",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.CREATE_ORGANIZATION.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.CREATE_ORGANIZATION.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/UpdateOrganization.vue"),
  },
  {
    path: PATH.MANAGE_PRICING,
    name: "managePricing",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.MANAGE_PRICING.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.MANAGE_PRICING.PERMISSIONS,
    },
    component: () => import("../views/ManagePricing.vue"),
  },
  {
    path: PATH.WEBSITE_MANAGEMENT,
    name: "websiteManagement",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.WEBSITE_MANAGEMENT.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.WEBSITE_MANAGEMENT.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/WebsiteMangement.vue"),
  },
  {
    path: PATH.WHATSAPP_MANAGEMENT,
    name: "whatsappManagement",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.WHATSAPP_MANAGEMENT.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.WHATSAPP_MANAGEMENT.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/WhatsappManagement.vue"),
  },
  {
    path: PATH.PASSENGER_MANAGEMENT,
    name: "passengerManagement",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.PASSENGER_MANAGEMENT.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.PASSENGER_MANAGEMENT.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/PassengerManagement.vue"),
  },
  {
    path: PATH.PASSENGER_PROFILE,
    name: "passengerProfile",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.PASSENGER_MANAGEMENT.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.PASSENGER_MANAGEMENT.PERMISSIONS,
    },
    component: () => import("../views/PassengerProfile.vue"),
  },
  {
    path: PATH.CURRENCY_CONVERSION,

    name: "currencyConversion",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.CURRENCY_CONVERSION.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.CURRENCY_CONVERSION.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/CurrencyConversion.vue"),
  },

  {
    path: PATH.ORGANIZATION_DOCUMENTS,

    name: "organizationDocuments",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION_DOCUMENTS.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION_DOCUMENTS.PERMISSIONS,
    },
    component: () => import("@/modules/Organization/views/UploadDocuments.vue"),
  },
  {
    path: PATH.SAAS_ELITE_ORGANIZATION,

    name: "saasOrganizations",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.SAAS_ORGANIZATIONS.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.SAAS_ORGANIZATIONS.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Organization/views/SaasEliteOrganizationList.vue"),
  },
];

export default routes;
